export enum RequestStatus {
    Open = 'open',
    InProgress = 'inProgress',
    OnHold = 'onHold',
    Closed = 'closed',
}
